import { editTemplateName } from 'api/TemplateIndexAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { displayContent } from '../common';
import { useQueryParamContext } from '../context/QueryParamContext';

export const useUpdateTemplateName = () => {
  const { templateId } = useQueryParamContext();

  const {
    reset,
    formState: { defaultValues: defaultTemplate },
  } = useFormContext();
  const dispatch = useDispatch();

  const onUpdateTemplateName = useCallback(
    (name: string) => {
      editTemplateName(templateId, name)
        .then(() => {
          dispatch(addPositiveToast(displayContent.strDataUpdatedSuccessfully({ dataName: name })));
          reset({ ...defaultTemplate, name }, { keepValues: true });
        })
        .catch((error: any) => {
          dispatch(addNegativeToast(displayContent.errUpdateTemplateName, error));
        });
    },
    [templateId, defaultTemplate],
  );

  return {
    onUpdateTemplateName,
  };
};
